import React from "react";
import type { ChatMessage } from "./types";

interface SystemMessageProps {
  message: ChatMessage;
  onRetry?: () => void;
}

export default function SystemMessage({ message, onRetry }: SystemMessageProps) {
  const isError = message.content.startsWith("Error:");
  const isRateLimit =
    message.content.includes("429") || message.content.toLowerCase().includes("rate limit");
  const isNetworkError =
    message.content.toLowerCase().includes("network") ||
    message.content.toLowerCase().includes("fetch") ||
    message.content.toLowerCase().includes("connection");

  let displayMessage = message.content;
  if (isNetworkError) {
    displayMessage = "Connection lost. Check your network and try again.";
  } else if (isRateLimit) {
    displayMessage = "Rate limited. Please wait a moment before trying again.";
  }

  return (
    <div className="flex justify-center">
      <div
        className="px-4 py-2.5 rounded-lg text-xs max-w-[80%] flex items-center gap-3"
        style={{
          backgroundColor: isError ? "var(--c-accent-subtle)" : "var(--c-surface)",
          border: `1px solid ${isError ? "rgba(229, 72, 77, 0.2)" : "var(--c-border)"}`,
          color: isError ? "var(--c-danger)" : "var(--c-text-secondary)",
        }}
      >
        {isError && (
          <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            className="shrink-0"
          >
            <circle cx="7" cy="7" r="6" />
            <path d="M7 4v3" />
            <circle cx="7" cy="9.5" r="0.5" fill="currentColor" />
          </svg>
        )}
        <span>{displayMessage}</span>
        {isError && onRetry && (
          <button
            onClick={onRetry}
            className="shrink-0 px-2 py-1 rounded text-[11px] font-medium transition-colors"
            style={{
              backgroundColor: "var(--c-surface)",
              border: "1px solid var(--c-border)",
              color: "var(--c-text)",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "var(--c-primary)";
              e.currentTarget.style.color = "var(--c-primary)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "var(--c-border)";
              e.currentTarget.style.color = "var(--c-text)";
            }}
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
}
